var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isEmpty, isNil, isNumber, toNumber } from 'lodash-es';
import { sdsCustomElement } from '../../utilities/custom-components';
import { SdsInputBase } from '../_sds-input-base';
import { appendZeros, cutValueToPrecision, removeLastDecimalPoint, shouldHandlePrecision, } from './precision-calculations';
import styles from './sds-input-number.lit.scss';
import { Big } from 'big.js';
/**
 * `sds-input-number` is a web component input field for numeric values.
 * It allows users to set minimum and maximum values, define step increments, and control precision.
 * Additional attributes manage the enable/disable state of increase and decrease buttons.
 *
 * ### Attributes
 * - `min`: The minimum value for the input.
 * - `max`: The maximum value for the input.
 * - `step`: The increment step for the input value. Defaults to `1`.
 * - `precision`: The number of decimal places for the input value.
 * - `disabled-increase`: Disables the increase button when set to true.
 * - `disabled-decrease`: Disables the decrease button when set to true.
 *
 * @tag sds-input-number
 */
let SdsInputNumber = (() => {
    var _SdsInputNumber_isDecimalNumber_accessor_storage, _SdsInputNumber_padDecimalZeros_accessor_storage, _SdsInputNumber_decimalSeparator_accessor_storage, _SdsInputNumber_thousandsSeparator_accessor_storage, _SdsInputNumber_min_accessor_storage, _SdsInputNumber_max_accessor_storage, _SdsInputNumber_step_accessor_storage, _SdsInputNumber_precision_accessor_storage, _SdsInputNumber_maxDigitCount_accessor_storage, _SdsInputNumber__input_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-number')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputBase;
    let _instanceExtraInitializers = [];
    let _isDecimalNumber_decorators;
    let _isDecimalNumber_initializers = [];
    let _isDecimalNumber_extraInitializers = [];
    let _padDecimalZeros_decorators;
    let _padDecimalZeros_initializers = [];
    let _padDecimalZeros_extraInitializers = [];
    let _decimalSeparator_decorators;
    let _decimalSeparator_initializers = [];
    let _decimalSeparator_extraInitializers = [];
    let _thousandsSeparator_decorators;
    let _thousandsSeparator_initializers = [];
    let _thousandsSeparator_extraInitializers = [];
    let _min_decorators;
    let _min_initializers = [];
    let _min_extraInitializers = [];
    let _max_decorators;
    let _max_initializers = [];
    let _max_extraInitializers = [];
    let _step_decorators;
    let _step_initializers = [];
    let _step_extraInitializers = [];
    let _precision_decorators;
    let _precision_initializers = [];
    let _precision_extraInitializers = [];
    let _maxDigitCount_decorators;
    let _maxDigitCount_initializers = [];
    let _maxDigitCount_extraInitializers = [];
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    let _set_disabledIncrease_decorators;
    let _set_disabledDecrease_decorators;
    var SdsInputNumber = _classThis = class extends _classSuper {
        constructor() {
            var _a, _b;
            super(...arguments);
            _SdsInputNumber_isDecimalNumber_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _isDecimalNumber_initializers, true)));
            _SdsInputNumber_padDecimalZeros_accessor_storage.set(this, (__runInitializers(this, _isDecimalNumber_extraInitializers), __runInitializers(this, _padDecimalZeros_initializers, false)));
            _SdsInputNumber_decimalSeparator_accessor_storage.set(this, (__runInitializers(this, _padDecimalZeros_extraInitializers), __runInitializers(this, _decimalSeparator_initializers, (_a = new Intl.NumberFormat().format(1.1).replace(/\d/g, '')[0]) !== null && _a !== void 0 ? _a : '')));
            _SdsInputNumber_thousandsSeparator_accessor_storage.set(this, (__runInitializers(this, _decimalSeparator_extraInitializers), __runInitializers(this, _thousandsSeparator_initializers, (_b = new Intl.NumberFormat().format(1111).replace(/\d/g, '')[0]) !== null && _b !== void 0 ? _b : '')));
            _SdsInputNumber_min_accessor_storage.set(this, (__runInitializers(this, _thousandsSeparator_extraInitializers), __runInitializers(this, _min_initializers, void 0)));
            _SdsInputNumber_max_accessor_storage.set(this, (__runInitializers(this, _min_extraInitializers), __runInitializers(this, _max_initializers, void 0)));
            _SdsInputNumber_step_accessor_storage.set(this, (__runInitializers(this, _max_extraInitializers), __runInitializers(this, _step_initializers, 1)));
            _SdsInputNumber_precision_accessor_storage.set(this, (__runInitializers(this, _step_extraInitializers), __runInitializers(this, _precision_initializers, 3)));
            _SdsInputNumber_maxDigitCount_accessor_storage.set(this, (__runInitializers(this, _precision_extraInitializers), __runInitializers(this, _maxDigitCount_initializers, void 0)));
            _SdsInputNumber__input_accessor_storage.set(this, (__runInitializers(this, _maxDigitCount_extraInitializers), __runInitializers(this, __input_initializers, void 0)));
            this._disabledDecrease = __runInitializers(this, __input_extraInitializers);
            this._shouldUpdateInput = false;
        }
        /**
         * Indicates whether the input should accept decimal numbers.
         * When set to `true`, the input allows decimal values.
         */
        get isDecimalNumber() { return __classPrivateFieldGet(this, _SdsInputNumber_isDecimalNumber_accessor_storage, "f"); }
        set isDecimalNumber(value) { __classPrivateFieldSet(this, _SdsInputNumber_isDecimalNumber_accessor_storage, value, "f"); }
        /**
         * Specifies the `padDecimalZeros` behavior for the input.
         * Accepts true to enable and false to disable browser padDecimalZeros.
         */
        get padDecimalZeros() { return __classPrivateFieldGet(this, _SdsInputNumber_padDecimalZeros_accessor_storage, "f"); }
        set padDecimalZeros(value) { __classPrivateFieldSet(this, _SdsInputNumber_padDecimalZeros_accessor_storage, value, "f"); }
        /**
         * Defines the character used as the decimal separator in numeric input.
         * Accepts either `'.'` or `','` depending on localization.
         */
        get decimalSeparator() { return __classPrivateFieldGet(this, _SdsInputNumber_decimalSeparator_accessor_storage, "f"); }
        set decimalSeparator(value) { __classPrivateFieldSet(this, _SdsInputNumber_decimalSeparator_accessor_storage, value, "f"); }
        /**
         * Defines the character used as the thousands separator in numeric input.
         * Useful for formatting large numbers. Common values include `'.'`, `','`, space `' '`, or an empty string `''`.
         */
        get thousandsSeparator() { return __classPrivateFieldGet(this, _SdsInputNumber_thousandsSeparator_accessor_storage, "f"); }
        set thousandsSeparator(value) { __classPrivateFieldSet(this, _SdsInputNumber_thousandsSeparator_accessor_storage, value, "f"); }
        /**
         * Minimum value for this input.
         * This property defines the lowest numeric value that can be entered.
         *
         * @attr {number} min - The minimum allowable value.
         */
        get min() { return __classPrivateFieldGet(this, _SdsInputNumber_min_accessor_storage, "f"); }
        set min(value) { __classPrivateFieldSet(this, _SdsInputNumber_min_accessor_storage, value, "f"); }
        /**
         * Maximum value for this input.
         * This property defines the highest numeric value that can be entered.
         *
         * @attr {number} max - The maximum allowable value.
         */
        get max() { return __classPrivateFieldGet(this, _SdsInputNumber_max_accessor_storage, "f"); }
        set max(value) { __classPrivateFieldSet(this, _SdsInputNumber_max_accessor_storage, value, "f"); }
        /**
         * Step by which the value of this input increases.
         * This property sets the increment value to apply when adjusting the number.
         *
         * Defaults to `1`.
         *
         * @attr {number} step - The increment step value.
         */
        get step() { return __classPrivateFieldGet(this, _SdsInputNumber_step_accessor_storage, "f"); }
        set step(value) { __classPrivateFieldSet(this, _SdsInputNumber_step_accessor_storage, value, "f"); }
        /**
         * Number of decimal places for the input value.
         * This property specifies the precision of the numeric value.
         *
         * @attr {number} precision - The number of decimal places.
         */
        get precision() { return __classPrivateFieldGet(this, _SdsInputNumber_precision_accessor_storage, "f"); }
        set precision(value) { __classPrivateFieldSet(this, _SdsInputNumber_precision_accessor_storage, value, "f"); }
        get maxDigitCount() { return __classPrivateFieldGet(this, _SdsInputNumber_maxDigitCount_accessor_storage, "f"); }
        set maxDigitCount(value) { __classPrivateFieldSet(this, _SdsInputNumber_maxDigitCount_accessor_storage, value, "f"); }
        get _input() { return __classPrivateFieldGet(this, _SdsInputNumber__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsInputNumber__input_accessor_storage, value, "f"); }
        get disabledIncrease() {
            return this.parseStringToNumber(this.value) === this.max || this.disabled;
        }
        /**
         * True if the increase button is disabled.
         * This attribute disables the increase control, preventing further increments.
         *
         * @attr {boolean} disabled-increase - Disables the increase button.
         */
        set disabledIncrease(value) {
            const oldValue = this._disabledIncrease;
            this._disabledIncrease = value;
            this.requestUpdate('disabledIncrease', oldValue);
        }
        get disabledDecrease() {
            return this.parseStringToNumber(this.value) === this.min || this.disabled;
        }
        /**
         * True if the decrease button is disabled.
         * This attribute disables the decrease control, preventing further decrements.
         *
         * @attr {boolean} disabled-decrease - Disables the decrease button.
         */
        set disabledDecrease(value) {
            const oldValue = this._disabledDecrease;
            this._disabledDecrease = value;
            this.requestUpdate('disabledDecrease', oldValue);
        }
        updated(changedProperties) {
            if (changedProperties.has('focused') && this.focused) {
                this.getInput().focus();
            }
            if (isNil(this.value)) {
                this.value = '';
            }
            const inputValue = this.parseStringToNumber(this.value);
            if (isNumber(inputValue)) {
                this.getInput().value = this.value.toString();
            }
        }
        render() {
            return html `
            <div class="${this.getClasses()} sds-input--number">
                <div class="sds-input__wrapper">
                    ${this.renderInput('text')} ${this.renderActions()}
                    ${this.renderActionContainer()}
                </div>
                ${this.renderMessages()}
            </div>
        `;
        }
        showClear() {
            return (!isNil(this.value) &&
                !isEmpty(this.value.toString()) &&
                !this.disabled &&
                this.hasClear &&
                this.rightAligned);
        }
        async firstUpdated(_changedProperties) {
            await this.updateComplete;
            super.firstUpdated(_changedProperties);
            if (_changedProperties.has('value')) {
                if (isNil(this.value)) {
                    this.value = '';
                }
                this.value = this.value.toString().replace('.', this.decimalSeparator);
                this.removeZerosFromStart();
                this.setAttribute('value', this.appendPrecisionZeros());
                this.requestUpdate('value');
                this._shouldUpdateInput = true;
            }
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('value')) {
                if (isNil(this.value)) {
                    this.value = '';
                }
                if (this._shouldUpdateInput) {
                    this.value = this.value.toString().replace('.', this.decimalSeparator);
                    this.updateInputOnAttributeChange();
                }
                else {
                    this._shouldUpdateInput = true;
                }
            }
        }
        getInput() {
            return this._input;
        }
        handleWheel(event) {
            if (!this.rightAligned && !this.noActions) {
                event.preventDefault();
                this.handleIncreaseOrDecrease(event.deltaY < 0 ? 'increase' : 'decrease');
            }
        }
        handleKeyDown(event) {
            if (!this.rightAligned && !this.noActions) {
                if (event.key === 'ArrowUp') {
                    this.handleIncreaseOrDecrease('increase');
                }
                else if (event.key === 'ArrowDown') {
                    this.handleIncreaseOrDecrease('decrease');
                }
            }
        }
        handleInput() {
            this.value = this.convertValue(this.getInput().value, true);
            this.dispatchCustomEvent(SdsInputNumber.INPUT_EVENT);
        }
        handleChanged() {
            this.removeZerosFromStart();
            const inputValue = this.parseStringToNumber(this.value);
            if (isNumber(inputValue)) {
                this.value = this.clampWithinMinMax(Number(inputValue));
                this.getInput().value = this.value.toString();
            }
            this.value = this.convertValue(this.getInput().value);
            this.dispatchCustomEvent(SdsInputBase.CHANGE_EVENT);
            this.dispatchCustomEvent(SdsInputNumber.NATIVE_INPUT_EVENT);
            this.dispatchCustomEvent(SdsInputBase.INPUT_EVENT);
        }
        handleFocus() {
            super.handleFocus();
            this.value = this.convertValue(this.getInput().value, true);
        }
        handleBlur() {
            super.handleBlur();
            this.handleChanged();
        }
        getDispatchedValue() {
            const parsedValue = this.parseStringToNumber(this.value);
            return isNaN(parsedValue) ? '' : parsedValue;
        }
        dispatchCustomEvent(event) {
            this.dispatchEvent(new CustomEvent(event, {
                detail: { value: this.getDispatchedValue() },
                bubbles: false,
                composed: false,
            }));
        }
        convertValue(value, isSanitize = false) {
            this._shouldUpdateInput = false;
            const sanitized = isSanitize
                ? this.sanitizeDecimalInput(value)
                : this.parseToLocaleString(value);
            const modifiedValue = this.handlePrecision(sanitized, this.decimalSeparator);
            if (modifiedValue !== value) {
                this.getInput().value = modifiedValue;
                value = modifiedValue;
            }
            this.requestUpdate('value');
            return value;
        }
        sanitizeDecimalInput(value) {
            let sanitizedValue = value.trim();
            sanitizedValue = this.removeThousandsSeparator(sanitizedValue);
            let result = '';
            let hasDot = false;
            let digitCount = 0;
            for (let i = 0; i < sanitizedValue.length; i++) {
                const char = sanitizedValue[i];
                const isDigit = char >= '0' && char <= '9';
                const isLeadingSign = i === 0 && this.isAllowedLeadingSign(char);
                const isValidDot = this.isDecimalNumber && char === this.decimalSeparator && !hasDot;
                if (isLeadingSign) {
                    result += char;
                }
                else if (isDigit) {
                    if (!isNil(this.maxDigitCount) && digitCount >= this.maxDigitCount) {
                        break;
                    }
                    result += char;
                    digitCount++;
                }
                else if (isValidDot) {
                    result += this.decimalSeparator;
                    hasDot = true;
                }
                else {
                    break;
                }
            }
            return result;
        }
        parseToLocaleString(value) {
            if (!value || isNaN(parseFloat(value)))
                return '';
            if (!this.thousandsSeparator)
                return value;
            if (value.startsWith(this.decimalSeparator)) {
                value = '0' + value;
            }
            else if (value.startsWith(`-${this.decimalSeparator}`)) {
                value = '-0' + value.substring(1);
            }
            const bigValue = value.toLowerCase().indexOf('e') > 0 ? Big(value).toFixed() : value;
            const [integerPart, decimalPart] = bigValue.split(this.decimalSeparator);
            let formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
            if (bigValue.indexOf(this.decimalSeparator) > 0 &&
                !bigValue.endsWith(this.decimalSeparator)) {
                formatted += this.decimalSeparator;
            }
            if (decimalPart !== undefined) {
                formatted += decimalPart;
            }
            return formatted;
        }
        isAllowedLeadingSign(char) {
            if (char === '-')
                return this.min === undefined || this.min < 0;
            return false;
        }
        parseStringToNumber(value, isRemoveThousandsSeparator = true) {
            value = isNil(value) ? '' : value.toString();
            let numberValue = value;
            if (isRemoveThousandsSeparator) {
                numberValue = this.removeThousandsSeparator(numberValue);
            }
            numberValue = numberValue.replace(this.decimalSeparator, '.');
            return parseFloat(numberValue);
        }
        removeThousandsSeparator(value) {
            return value.replaceAll(this.thousandsSeparator, '');
        }
        emptyValue() {
            return '';
        }
        clampWithinMinMax(value) {
            if (value < this.min) {
                return Big(this.min).toFixed();
            }
            if (value > this.max) {
                return Big(this.max).toFixed();
            }
            return this.value.toString();
        }
        appendPrecisionZeros() {
            if (this.padDecimalZeros &&
                !isNil(this.precision) &&
                this.precision > 0 &&
                toNumber(this.value) !== 0) {
                return appendZeros(this.value.toString(), this.decimalSeparator, this.precision);
            }
            return this.value.toString();
        }
        removeZerosFromStart() {
            var _a;
            let value = (_a = this.getInput()) === null || _a === void 0 ? void 0 : _a.value;
            if (!value || value === '0' || value === `0${this.decimalSeparator}` || value === '-')
                return;
            const cleaned = value.replace(/^(-?)0+(?=\d)/, '$1');
            if (cleaned !== value) {
                value = cleaned;
                this.value = this.parseStringToNumber(cleaned, false) || '';
            }
        }
        updateInputOnAttributeChange() {
            const modifiedValue = this.parseToLocaleString(removeLastDecimalPoint(this.handlePrecision(this.value.toString(), this.decimalSeparator), this.decimalSeparator));
            this.getInput().value = modifiedValue;
            this.value = modifiedValue;
        }
        handlePrecision(value, decimalSeparator) {
            return shouldHandlePrecision(value, decimalSeparator, this.precision)
                ? cutValueToPrecision(value, decimalSeparator, this.precision)
                : value;
        }
        handleIncreaseOrDecrease(direction) {
            const val = this.parseStringToNumber(this.value) || '';
            const stepValue = direction === 'increase' ? this.step : -this.step;
            this.value = (Number(val) + stepValue).toString();
            this.value = this.clampWithinMinMax(Number(this.value));
            this.removeZerosFromStart();
            this.dispatchCustomEvent(SdsInputNumber.INPUT_EVENT);
            this.dispatchCustomEvent(SdsInputBase.ACTION_EVENT);
            this.dispatchCustomEvent(SdsInputBase.CHANGE_EVENT);
        }
        getIncreaseClasses() {
            return classMap({
                'sds-input__control': true,
                'sds-input__control--increase': true,
                'sds-input__control--disabled': this.disabledIncrease,
            });
        }
        renderActions() {
            if (!this.rightAligned && !this.noActions) {
                return html `
                <button
                    type="button"
                    class="${this.getIncreaseClasses()}"
                    @click="${() => this.handleIncreaseOrDecrease('increase')}"
                    ?disabled="${this.disabledIncrease}"
                >
                    <sds-icon name="arrow_up_small" size="16"></sds-icon>
                </button>

                <button
                    type="button"
                    class="${this.getDecreaseClasses()}"
                    @click="${() => this.handleIncreaseOrDecrease('decrease')}"
                    ?disabled="${this.disabledDecrease}"
                >
                    <sds-icon name="arrow_down_small" size="16"></sds-icon>
                </button>
            `;
            }
        }
        getDecreaseClasses() {
            return classMap({
                'sds-input__control': true,
                'sds-input__control--decrease': true,
                'sds-input__control--disabled': this.disabledDecrease,
            });
        }
    };
    _SdsInputNumber_isDecimalNumber_accessor_storage = new WeakMap();
    _SdsInputNumber_padDecimalZeros_accessor_storage = new WeakMap();
    _SdsInputNumber_decimalSeparator_accessor_storage = new WeakMap();
    _SdsInputNumber_thousandsSeparator_accessor_storage = new WeakMap();
    _SdsInputNumber_min_accessor_storage = new WeakMap();
    _SdsInputNumber_max_accessor_storage = new WeakMap();
    _SdsInputNumber_step_accessor_storage = new WeakMap();
    _SdsInputNumber_precision_accessor_storage = new WeakMap();
    _SdsInputNumber_maxDigitCount_accessor_storage = new WeakMap();
    _SdsInputNumber__input_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputNumber");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _isDecimalNumber_decorators = [property({ type: Boolean })];
        _padDecimalZeros_decorators = [property({ type: Boolean })];
        _decimalSeparator_decorators = [property({ type: String })];
        _thousandsSeparator_decorators = [property({ type: String })];
        _min_decorators = [property({ type: Number })];
        _max_decorators = [property({ type: Number })];
        _step_decorators = [property({ type: Number })];
        _precision_decorators = [property({ type: Number })];
        _maxDigitCount_decorators = [property({ type: Number })];
        __input_decorators = [query('input.sds-input__element')];
        _set_disabledIncrease_decorators = [property({ type: Boolean, attribute: 'disabled-increase' })];
        _set_disabledDecrease_decorators = [property({ type: Boolean, attribute: 'disabled-decrease' })];
        __esDecorate(_classThis, null, _isDecimalNumber_decorators, { kind: "accessor", name: "isDecimalNumber", static: false, private: false, access: { has: obj => "isDecimalNumber" in obj, get: obj => obj.isDecimalNumber, set: (obj, value) => { obj.isDecimalNumber = value; } }, metadata: _metadata }, _isDecimalNumber_initializers, _isDecimalNumber_extraInitializers);
        __esDecorate(_classThis, null, _padDecimalZeros_decorators, { kind: "accessor", name: "padDecimalZeros", static: false, private: false, access: { has: obj => "padDecimalZeros" in obj, get: obj => obj.padDecimalZeros, set: (obj, value) => { obj.padDecimalZeros = value; } }, metadata: _metadata }, _padDecimalZeros_initializers, _padDecimalZeros_extraInitializers);
        __esDecorate(_classThis, null, _decimalSeparator_decorators, { kind: "accessor", name: "decimalSeparator", static: false, private: false, access: { has: obj => "decimalSeparator" in obj, get: obj => obj.decimalSeparator, set: (obj, value) => { obj.decimalSeparator = value; } }, metadata: _metadata }, _decimalSeparator_initializers, _decimalSeparator_extraInitializers);
        __esDecorate(_classThis, null, _thousandsSeparator_decorators, { kind: "accessor", name: "thousandsSeparator", static: false, private: false, access: { has: obj => "thousandsSeparator" in obj, get: obj => obj.thousandsSeparator, set: (obj, value) => { obj.thousandsSeparator = value; } }, metadata: _metadata }, _thousandsSeparator_initializers, _thousandsSeparator_extraInitializers);
        __esDecorate(_classThis, null, _min_decorators, { kind: "accessor", name: "min", static: false, private: false, access: { has: obj => "min" in obj, get: obj => obj.min, set: (obj, value) => { obj.min = value; } }, metadata: _metadata }, _min_initializers, _min_extraInitializers);
        __esDecorate(_classThis, null, _max_decorators, { kind: "accessor", name: "max", static: false, private: false, access: { has: obj => "max" in obj, get: obj => obj.max, set: (obj, value) => { obj.max = value; } }, metadata: _metadata }, _max_initializers, _max_extraInitializers);
        __esDecorate(_classThis, null, _step_decorators, { kind: "accessor", name: "step", static: false, private: false, access: { has: obj => "step" in obj, get: obj => obj.step, set: (obj, value) => { obj.step = value; } }, metadata: _metadata }, _step_initializers, _step_extraInitializers);
        __esDecorate(_classThis, null, _precision_decorators, { kind: "accessor", name: "precision", static: false, private: false, access: { has: obj => "precision" in obj, get: obj => obj.precision, set: (obj, value) => { obj.precision = value; } }, metadata: _metadata }, _precision_initializers, _precision_extraInitializers);
        __esDecorate(_classThis, null, _maxDigitCount_decorators, { kind: "accessor", name: "maxDigitCount", static: false, private: false, access: { has: obj => "maxDigitCount" in obj, get: obj => obj.maxDigitCount, set: (obj, value) => { obj.maxDigitCount = value; } }, metadata: _metadata }, _maxDigitCount_initializers, _maxDigitCount_extraInitializers);
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(_classThis, null, _set_disabledIncrease_decorators, { kind: "setter", name: "disabledIncrease", static: false, private: false, access: { has: obj => "disabledIncrease" in obj, set: (obj, value) => { obj.disabledIncrease = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _set_disabledDecrease_decorators, { kind: "setter", name: "disabledDecrease", static: false, private: false, access: { has: obj => "disabledDecrease" in obj, set: (obj, value) => { obj.disabledDecrease = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputNumber = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputNumber = _classThis;
})();
export { SdsInputNumber };
